import { tns } from 'tiny-slider';
import { apiRequest2 } from '../api/apiRequest';
import { generateSvgDataUrl } from '../util/generateSvgDataUrl';
import { apiConfig } from "../config/apiConfig";
import { restructureImagesV2 } from '../util/imageQuality';
import { insertTemplate, lookupTemplate } from "../services/woker-api";
import { createVDOMHash, keyGenerator } from "../util/keyGeneration";


export class ClientTransformCarousel {
    private static instance: ClientTransformCarousel;
    private readonly pageSize: number;

    static getInstance(): ClientTransformCarousel {
        if (!ClientTransformCarousel.instance) {
            ClientTransformCarousel.instance = new ClientTransformCarousel();
        }
        return ClientTransformCarousel.instance;
    }

    private constructor() {
        this.pageSize = 9;

    }

    //response to be passed to the slider
    private transFormationSliderV2() {
        let transfSlider2 = document.querySelector(".transformation-carousel-list.transformation-slider-v2");
        if (transfSlider2) {
            tns({
                container: transfSlider2,
                items: 1,
                loop: false,
                gutter: 10,
                controlsText: ['<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
            });
        }
    }

    getData() {
        this.fetchDiaryData();
    }

    // Helper to show review section
    HideSections(fullReviewBox?: HTMLElement, profileWrapper?: HTMLElement, nameElement?: HTMLElement, ratingContainer?: HTMLElement) {
        if (fullReviewBox) {
            fullReviewBox.classList?.remove('hidden');
            fullReviewBox.style.display = 'flex';
        }
        profileWrapper?.classList?.remove('hidden');
        nameElement?.classList?.remove('hidden');
        ratingContainer?.classList?.remove('hidden');
    }

    formatAppointmentDate(rawDate: string): string {
        if (!rawDate) return '';
        const timestamp = Number.parseInt(rawDate.replace(/\D/g, ''));
        const date = new Date(timestamp);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }
 addReadToggle(clientTextEl: HTMLElement): void {
    try {
        const isClamped = clientTextEl?.scrollHeight > clientTextEl?.clientHeight;

        if (isClamped) {
            const toggle = document.createElement("span");
            toggle.className = "read-toggle";
            toggle.innerText = "Read More";

            toggle.addEventListener("click", () => {
                clientTextEl.classList.toggle("expanded");
                toggle.innerText = clientTextEl.classList.contains("expanded")
                    ? "Read Less"
                    : "Read More";
            });

            clientTextEl.insertAdjacentElement("afterend", toggle);
        } else {
            // Expand text if not clamped
            clientTextEl.classList.add("expanded");
        }
    } catch (err) {
        console.warn("Error checking text clamp:", err);
        clientTextEl.classList.add("expanded"); // fallback
    }
}

    //Last Name of the customer to be having only single letter
    private formatCustomerName(fullName: string): string {
        const nameArray = fullName.match(/\b[a-zA-Z]+\b/g) as string[];
        if (nameArray.length === 1) {
            return nameArray[0];
        }
        if (nameArray.length >= 2) {
            return `${nameArray[0]} ${nameArray[1].charAt(0).toUpperCase()}.`;
        }
        return fullName;
    }

    private handleReadMore(fullReviewBox: HTMLElement, clientTextEl: HTMLElement) {
        if (!clientTextEl) { return; }
        if (fullReviewBox?.style?.display === "flex") {
            if (clientTextEl) {
                requestAnimationFrame(() => {
                    // Check if content exceeds clamp (max-height)
                    this.addReadToggle(clientTextEl);
                });
            }
        } else if (clientTextEl) {
                // Expand text if not visible
                clientTextEl.classList.add('expanded');
        }
    }   
    async fetchDiaryData(): Promise<void> {
        const pathName = window.location.pathname;
        const requestBody = {
            "url": pathName,
            "pageSize": this.pageSize ?? 9
         };
         //adding a trailing slash if not present in pathname
         if (!requestBody.url?.endsWith('/')) {
            requestBody.url += '/';
        }
        const request = {
            method: 'POST',
            url: apiConfig.DOK_DIARY_DATA,
            headers: {
                'Content-Type': 'application/json'
             },
            data: requestBody,
        };
        const skeletonView = document.getElementById('skeleton-view');
        const carouselContainer = document.getElementById('carousel-container');
        const baseUrl = `${process.env.JS_API_DOK}`;
        try {
            skeletonView?.classList?.remove('hidden');
            carouselContainer?.classList?.add('hidden');

            const ulSelector = '.transformation-section.testimonials .transformation-carousel-wrap .transformation-carousel-list.transformation-slider-v2';
            const ul = document.querySelector(ulSelector);
            const templateLi = ul?.querySelector('.transformation-carousel-item');
            if (!ul || !templateLi) return;

            // Use keyGenerator for cache key
            const cacheKey = keyGenerator(`${apiConfig.CLIENT_TRANSFORM_CAROUSEL_V2}-[url path]-${pathName}`, ulSelector);
             const data = await this.getCarouselData(cacheKey, request);
             const section = document.querySelector('.transformation-section.testimonials') as HTMLElement;

            if (!data?.length) {
                if (section) {
                    section.classList?.add('hidden'); // or section.style.display = 'none';
                } 
                return;
            }

            data.forEach((item: any, index: number) => {
                const clone = templateLi.cloneNode(true) as HTMLElement;
                this.setImageData(clone, item, index, baseUrl);
                

                (clone.querySelector('.client-heading') as HTMLElement).innerText =
                    `${item?.jobCategory ?? 'Project'} in ${item?.appointmentCity ?? ''}${item?.appointmentState ? ', ' + item?.appointmentState : ''}`;

                (clone.querySelector('.date-text') as HTMLElement).innerText =
                    this.formatAppointmentDate(item?.appointmentDate ?? '');

                (clone.querySelector('.client-text') as HTMLElement).innerText = item?.description ?? '';
                const commentText = item?.comments ? `"${item?.comments}"` : '';
                const commentParagraph = clone.querySelector('.body-text-sm') as HTMLElement;
                commentParagraph.innerText = commentText;

                const profileImg = clone.querySelector('.testi-profile img') as HTMLImageElement;
                const nameElement = clone.querySelector('.user-name') as HTMLElement;                 
                const profileWrapper = clone.querySelector('.testi-profile') as HTMLElement;
                const ratingContainer = clone.querySelector('.rating') as HTMLElement;

                const fullReviewBox = clone.querySelector('.testi-main') as HTMLElement;
                const commentSection = clone.querySelector('.testi-comment') as HTMLElement;
                const customerName = item?.customerName?.trim() || "Customer Testimonial";
                const hasRating = typeof item?.rating === 'number';
                const hasComments = !!item?.comments?.trim();

                const svgDataUrl = generateSvgDataUrl(customerName?.charAt(0));
                profileImg.src = svgDataUrl;
                profileImg.alt = item?.customerName?.charAt(0);

                nameElement.innerText = this.formatCustomerName(customerName);
                profileWrapper.classList?.remove('hidden');
                nameElement.classList?.remove('hidden');

                // Set Rating
                if (hasRating) {
                    ratingContainer.innerHTML = new Array(5).fill('').map((_, i) =>
                        `<span class="star ${i < Math.round(item?.rating / 2) ? 'full' : ''}">★</span>`
                    ).join('');
                    ratingContainer.classList?.remove('hidden');
                } else {
                    ratingContainer.innerHTML = '';
                    ratingContainer.classList?.add('hidden');
                }

                // Set Comments
                if (hasComments) {
                    commentParagraph.innerText = `"${item?.comments}"`;
                    commentSection.classList?.remove('hidden');
                    commentParagraph.classList?.remove('hidden');
                } else {
                    commentParagraph.innerText = '';
                    commentSection.classList?.add('hidden');
                    commentParagraph.classList?.add('hidden');
                }

                const showFullReview = hasRating && hasComments;
                const showNameRatingOnly = hasRating && !hasComments;

                if (showFullReview) {
                    commentSection?.classList?.remove('hidden');
                    commentParagraph?.classList?.remove('hidden');
                    this.HideSections(fullReviewBox, profileWrapper, nameElement, ratingContainer);
                } else if (showNameRatingOnly) {
                    commentSection?.classList?.add('hidden');
                    commentParagraph?.classList?.add('hidden');
                    this.HideSections(fullReviewBox, profileWrapper, nameElement, ratingContainer);
                } else {
                    // Not valid - hide all
                    if (fullReviewBox) {
                        fullReviewBox.classList.add('hidden');
                        fullReviewBox.style.display = 'none';
                    }
                    commentSection?.classList?.add('hidden');
                    commentParagraph?.classList?.add('hidden');
                    profileWrapper?.classList?.add('hidden');
                    nameElement?.classList?.add('hidden');
                    ratingContainer?.classList?.add('hidden');
                }
                //Add Read More/Read Less only if testi-main is flex
                this.handleReadMore(
                    clone.querySelector('.testi-main') as HTMLElement,
                    clone.querySelector('.client-text') as HTMLElement
                );
                ul.appendChild(clone);
            });
            // Remove the template <li> after cloning
            templateLi.remove();
            // Unhide carousel and initialize Tiny Slider
            ul.classList?.remove('hidden');
            this.transFormationSliderV2();
            this.photoGalleryV2ImageHelper();

        } catch (err) {
            console.error('Error fetching diary data:', err);
        } finally {
            skeletonView?.classList.add('hidden');
            carouselContainer?.classList.remove('hidden');
        }
    }

     photoGalleryV2ImageHelper() {
        try {
        const domElements = document.querySelectorAll('.transformation-section.testimonials .transformation-carousel-wrap .tns-outer .transformation-carousel-list');
        if (domElements?.length === 0) return;
        domElements.forEach(element => {
            if (element) {
                restructureImagesV2(element as HTMLUListElement);
            }
        });
        } catch (error) {
            console.warn('Error in photoGalleryV2ImageHelper:', error);
        }
     }
       
    private setImageData(clone: HTMLElement, item: any, index: number, baseUrl: string): void {
        const beforeImg = clone.querySelector('.before-img img') as HTMLImageElement;
        const afterImg = clone.querySelector('.after-img img') as HTMLImageElement;
        const handleImg = clone.querySelector('.the-handle') as HTMLImageElement;

        beforeImg.src = item?.beforeImageUrl ? `${baseUrl}${item.beforeImageUrl}` : '';
        beforeImg.alt = `before-${index + 1}`;
        afterImg.src = item?.afterImageUrl ? `${baseUrl}${item.afterImageUrl}` : '';
        afterImg.alt = `after-${index + 1}`;
        handleImg.src = '/brand/_assets/images/brand-img/tranformation/circle-1.svg';
        handleImg.alt = 'handle';
    }
    private async getCarouselData(cacheKey: string, request: any): Promise<any[]> {
        let data: any[] = [];
        let hash: string | null = null;

        const cached = await this.getCarouselCache(cacheKey);
        hash = cached?.responseHash ?? null;
        if (cached?.generatedTemplate && hash) {
            // Generate hash for current VDOM
            const vdomNodes = JSON.parse(cached.generatedTemplate);
            const currentHash = await createVDOMHash(vdomNodes);
            if (currentHash === hash) {
                data = vdomNodes;
            } else {
                // Hash mismatch, fetch from API
                const response: any = await apiRequest2(request);
                data = response?.data ?? [];
                if (data.length > 0) {
                    const newHash = await createVDOMHash(data);
                    await this.storeCarouselCache(cacheKey, data, newHash);
                }
            }
        } else {
            // No cache, fetch from API
            const response: any = await apiRequest2(request);
            data = response?.data ?? [];
            if (data.length > 0) {
                const newHash = await createVDOMHash(data);
                await this.storeCarouselCache(cacheKey, data, newHash);
            }
        }
        return data;
    }

    // Overwrite storeCarouselCache to accept hash
    async storeCarouselCache(key: string, data: any, responseHash?: string): Promise<void> {
        try {
            await insertTemplate(key, {
                responseHash: responseHash ?? '',
                generatedTemplate: JSON.stringify(data),
                expiryTimestamp: Date.now() + (24 * 60 * 60 * 1000) // 24 hours
            });
        } catch (error) {
            console.warn('Error storing carousel data in cache:', error);
        }
    }

    async getCarouselCache(key: string): Promise<any> {
        try {
            const cached = await lookupTemplate(key);
            return cached ?? null;
        } catch (error) {
            console.warn('Error retrieving carousel data from cache:', error);
            return null;
        }
    }
}

 

/**
 * Refactor asynchronous operation outside of the constructor by triggering data fetch
 * only after DOMContentLoaded and when the expected container exists. Also guard
 * against multiple registrations in test environments.
 */
if (typeof document !== 'undefined') {
    const LISTENER_FLAG = '__ctc_listener_registered__';
    const w = (globalThis as any);
    if (!w[LISTENER_FLAG]) {
        document.addEventListener('DOMContentLoaded', () => {
            const hasContainer = document.querySelector('.transformation-section.testimonials .transformation-carousel-wrap');
            if (hasContainer) {
                const instance = ClientTransformCarousel.getInstance();
                // Trigger async work outside constructor
                instance.getData();
            }
        });
        w[LISTENER_FLAG] = true;
    }
}

